module.exports = __webpack_public_path__ + "img/whatsapp.ad37bd47.svg";